import { ApiResponse, AppliedCoupon, OrderCoupon, Voucher } from "../../../types";
import { getRequest, getRequestWithAuth, patchRequestWithAuth } from "../configuration";
import getApiWithVersion from "../apis";
import { API_VERSION } from "../../constants/common";
import { VoucherListPaylod, VoucherRemovePayload } from "../../../types/voucher.type";
const api = getApiWithVersion(API_VERSION.V1);


export interface API_Voucher{
    removeVoucher(data:VoucherRemovePayload,item_id:any):Promise<any>
    applyOrderLevelVoucher(data:VoucherRemovePayload,item_id:any):Promise<any>
    getVoucherList(queryPayload:VoucherListPaylod):Promise<ApiResponse<Voucher[]>>
    getAllVouchers():Promise<any>
    getCatAllVouchers(cat_id:any):Promise<any>
   
}

const voucher: API_Voucher = {
  removeVoucher(data,item_id){
    return patchRequestWithAuth(api.VOUCHER_REMOVE,data,item_id)
  },
  applyOrderLevelVoucher(data,item_id){
    return patchRequestWithAuth(api.VOUCHER_REMOVE,data,item_id)
  },
  getVoucherList(queryPayload) {
   
    return getRequestWithAuth(api.VOUCHER_LIST, undefined, queryPayload)
  },
  getAllVouchers(){
    return getRequest(api.VOUCHERS)
  },
  getCatAllVouchers(cat_id:any){
    return getRequest(api.VOUCHERS_CAT,cat_id)

  }

}

export default voucher

